// extracted by mini-css-extract-plugin
    if(module.hot) {
      // 1761558495008
      var cssReload = require("/Users/wumingbao/Desktop/hxproject/qingfa/erp-flexible-web21/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"hmr":true,"publicPath":"../","locals":false});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);
    }
  